if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: true,
        loaded: [],
        select(index) {
          this.currentTab = index;
        },
        async loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;

            try {
              let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
              const response = await fetch(url, {
                method: 'GET'
              });
              const responseText = await response.text();
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);

              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);

                // Wait for Alpine to process the new content
                await this.$nextTick();

                // Dispatch event to notify splide initialization
                document.dispatchEvent(new CustomEvent(`featured-collection:${this.sectionId}:loaded`, {
                  detail: { index }
                }));
              }
            } catch (error) {
              console.error('Error loading collection data:', error);
            } finally {
              this.loading = false;
            }
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto');
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}